<template>
    <div class="c-trim-selector" v-if="loaded">
        <div class="c-trim-selector__inner" v-if="$root.pickup == '1'">
            <div class="c-trim-selector__item">
                <div class="o-select__wrap">
                    <select class="o-select o-select-simple" v-model="trimName">
                        <option v-for="(name,index) in trimNames" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item -half">
                <div class="o-select__wrap -ico -cabine">
                    <select class="o-select o-select-simple" v-model="cabine">
                        <option v-for="(name,index) in cabines" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item -half">
                <div class="o-select__wrap -ico -caisse">
                    <select class="o-select o-select-simple" v-model="caisse">
                        <option v-for="(name,index) in caisses" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item" v-if="moteurs.length > 1">
                <div class="o-select__wrap -ico -moteur">
                    <select class="o-select o-select-simple" v-model="moteur">
                        <option v-for="(name, index) in moteurs" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item -half">
                <div class="o-select__wrap -ico -roue">
                    <select class="o-select o-select-simple" v-model="roue">
                        <option v-for="(name,index) in roues" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item -half" v-if="tractions.length > 1">
                <div class="o-select__wrap -ico -traction">
                    <select class="o-select o-select-simple" v-model=" traction">
                        <option v-for="(name,index) in tractions" :key="index" :value="name">{{ name }}</option>
                    </select>
                </div>
            </div>

        </div>
        <div v-else>
            <div class="c-trim-selector__item">
                <div class="o-select__wrap">
                    <select class="o-select o-select-simple" v-model="trimIndex">
                        <option v-for="(trim,index) in trims" :key="index" :value="index">{{ trim.name }}</option>
                    </select>
                </div>
            </div>
            <div class="c-trim-selector__item">
                <div class="o-select__wrap" v-if="currentTrim.options">
                    <select class="o-select o-select-simple" v-model="optionIndex">
                        <option v-for="(option,index) in currentTrim.options" :key="index" :value="index">{{ option.name
                            }}</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TrimSelector',

    data() {
        return {
            trims: window.trims,
            loaded: false,
            trimIndex: 0,
            optionIndex: 0,
            // For pickups
            trimName: '',
            cabine: '',
            caisse: '',
            roue: '',
            moteur: '',
            traction: '',
        }
    },
    computed: {
        currentTrim() {
            if (this.$root.pickup == 1) {
                return this.trims.find(trim => trim.name == this.trimName && trim.cabine == this.cabine && trim.caisse == this.caisse && trim.roues == this.roue);
            }
            else return this.trims[this.trimIndex];
        },
        trimNames() {
            let names = this.trims.map(trim => trim.name);
            // Array of unique values
            return names.filter((name, index) => names.indexOf(name) === index);
        },
        cabines() {
            let cabines = this.trims.filter(trim => trim.name == this.trimName).map(trim => trim.cabine);
            return cabines.filter((cabine, index) => cabines.indexOf(cabine) === index);
        },
        caisses() {
            let caisses = this.trims.filter(trim => trim.name == this.trimName && trim.cabine == this.cabine).map(trim => trim.caisse);
            return caisses.filter((caisse, index) => caisses.indexOf(caisse) === index);
        },
        roues() {
            let roues = this.trims.filter(trim => trim.name == this.trimName && trim.cabine == this.cabine && trim.caisse == this.caisse).map(trim => trim.roues);
            return roues.filter((roue, index) => roues.indexOf(roue) === index);
        },
        moteurs() {
            let trims = this.trims.filter(trim => trim.name == this.trimName && trim.cabine == this.cabine && trim.caisse == this.caisse && trim.roues == this.roue)
            let moteurs=[];
            trims.forEach(trim => {
                if (trim.options) {
                    trim.options.forEach(option => {
                        moteurs.push(option.name);
                    });
                }
                else {
                    moteurs.push(trim.moteur);
                }
            });
            return moteurs.filter((moteur, index) => moteurs.indexOf(moteur) === index);
        },
        tractions() {
            let trims = this.trims.filter(trim => trim.name == this.trimName && trim.cabine == this.cabine && trim.caisse == this.caisse && trim.roues == this.roue)
            let tractions=[];
            trims.forEach(trim => {
                if (trim.options) {
                    trim.options.forEach(option => {
                        if (option.name == this.moteur) tractions.push(option.traction);
                    });
                }
                else {
                    if (trim.moteur == this.moteur) tractions.push(trim.traction);
                }
            });
            return tractions.filter((traction, index) => tractions.indexOf(traction) === index);
        }
    },
    methods: {
        updateOption() {
            // Select the good trim / option
            let option;
            let trims = this.trims.filter(trim => trim.name == this.trimName && trim.cabine == this.cabine && trim.caisse == this.caisse && trim.roues == this.roue)
            trims.find(trim => {
                if (trim.options) {
                    option = trim.options.find(option => option.name == this.moteur && option.traction == this.traction);
                }
            });
            if (option) {
                let row = option.payments.row;
                row[3] = option.pdsf.toString()
                document.$trigger('rowChanged', {row: option.payments.row});
                document.$trigger('optionChanged', {option: option});
            }
        }
    },
    watch: {
        cabines() {
            if (!this.cabines.includes(this.cabine)) {
                this.cabine = this.cabines[0];
            }
        },
        caisses() {
            if (!this.caisses.includes(this.caisse)) {
                this.caisse = this.caisses[0];
            }
        },
        roues() {
            if (!this.roues.includes(this.roue)) {
                this.roue = this.roues[0];
            }
        },
        moteurs() {
            if (!this.moteurs.includes(this.moteur)) {
                this.moteur = this.moteurs[0];
            }
        },
        tractions() {
            if (!this.tractions.includes(this.traction)) {
                this.traction = this.tractions[0];
            }
        },
        trimNames() {
            if (!this.trimNames.includes(this.trimName)) {
                this.trimName = this.trimNames[0];
            }
        },
        
        moteur() {
            this.updateOption();
        },
        traction() {
            this.updateOption();
        },
        optionIndex() {
            document.$trigger('rowChanged', {row: this.currentTrim.options[this.optionIndex].payments.row});
            document.$trigger('optionChanged', {option: this.currentTrim.options[this.optionIndex]});
        },
        trimIndex() {
            if (this.currentTrim) document.$trigger('trimChanged', {trim: this.currentTrim});
        },
        currentTrim() {
            if (this.currentTrim) document.$trigger('trimChanged', {trim: this.currentTrim});
        },

    },
    mounted() {
        this.loaded = true;
        if (this.$root.pickup == 1) {
            this.trimName = this.trims[0].name;
            this.cabine = this.cabines[0];
            this.caisse = this.caisses[0];
            this.roue = this.roues[0];
            this.moteur = this.moteurs[0];
            this.traction = this.tractions[0];
        }
        
        setTimeout(() => {
            document.$trigger('trimChanged', {trim: this.currentTrim});
        }, 150);
    },
    
}
</script>